import { CSSProperties } from "react";

export type roadMapStylesProps = {
    contentWrapper: CSSProperties;
    contentWrapperMobile: CSSProperties
    contentWrapperDesktop: CSSProperties
    headingWrapper: CSSProperties
    col1: CSSProperties;
    col2: CSSProperties;
    btn_wrapper: CSSProperties;
    btn_wrapper_mobile: CSSProperties;
    buttonstyle: CSSProperties;
}

export const roadMapStyles: roadMapStylesProps = {
    contentWrapper: {
        display: "flex",
        marginTop: "18px"
    },
    contentWrapperMobile: {
        flexDirection: "column"
    },
    contentWrapperDesktop: {
        gap: "18px"
    },
    headingWrapper: {
        display: "flex",
        justifyContent: "space-between"
    },
    col1: {
        flex: 1,
        position: "relative"
    },
    col2: {
        flex: 3,
        border: " 1px solid #ccc",
        borderRadius: "8px",
        padding: "10px",
    },
    btn_wrapper: {

    },
    btn_wrapper_mobile: {
        zIndex: 1,
        background: "#fff",
        border: "1px solid var(--primary-color)",
        position: "absolute",
        right: "0",
        top: "0px",
        width: "180px",
    },
    buttonstyle: {
        marginBottom: "8px",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "18px",
        fontWeight: "700",
        lineHeight: "24px"
    }
}